export enum ParcelSizes {
  A4Evelope = 'parcel-a4-envelope',
  Small = 'parcel-small',
  Medium = 'parcel-medium',
  Large = 'parcel-large',
  XLarge = 'parcel-xlarge',
}
